import { render } from "./PageLayout.vue?vue&type=template&id=107a1f2b&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=107a1f2b&lang=scss&scoped=true"

import exportComponent from "D:\\ZAHB\\live-sdk-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107a1f2b"]])

export default __exports__